import { SUGGESTED_CATEGORIES } from '@everplan/shared';

export function mergeCategorySuggestions(userCategories: readonly string[]): string[] {
  const seen = new Set<string>();
  const out: string[] = [];
  for (const name of [...userCategories, ...SUGGESTED_CATEGORIES]) {
    const key = name.toLowerCase();
    if (seen.has(key)) continue;
    seen.add(key);
    out.push(name);
  }
  return out.sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()));
}
